<template>
  <div :style="{margin:gap}"><slot></slot></div>
</template>

<script>
export default {
  name: 'box',
  props: {
    gap: String
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/vux/src/components/box/index.vue